import React from 'react';
import {
  View,
  TouchableOpacity,
  StyleSheet,
  Platform,
  Alert,
  Text,
} from 'react-native';
import { H2, ButtonText } from '../../../components/common/TextStyles';
import { useTheme, getColor, spacing, getBorderRadius } from '../../../theme/useTheme';
import { Ionicons } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
const AdminHeader = (props) => {
  const navigation = useNavigation();
  const title = props.options?.title || props.route?.name || 'Admin Panel';

  return (
    <View style={styles.header}>
      <View style={styles.leftSection}>
        {props.back && (
          <TouchableOpacity
            onPress={navigation.goBack}
            style={styles.backButton}
          >
            <Ionicons name="arrow-back" size={24} color={getColor('text.primary')} />
          </TouchableOpacity>
        )}
        <H2 style={styles.title}>{title}</H2>
      </View>

      <View style={styles.rightSection} />
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: getColor('background.paper'),
    padding: spacing('lg'),
    height: 78,
    borderBottomWidth: 1,
    borderBottomColor: getColor('divider'),
    width: '100%',
    ...(Platform.OS === 'web' ? {
      position: 'sticky',
      top: 0,
      zIndex: 40,
    } : {})
  },
  leftSection: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing('md'),
    flex: 1,
  },
  backButton: {
    padding: spacing('sm'),
    marginLeft: -spacing('sm'),
    borderRadius: getBorderRadius('full'),
  },
  title: {
    color: getColor('text.primary'),
    fontSize: 20,
    fontWeight: '600',
    ...(Platform.OS === 'web' ? {
      fontFamily: 'Inter'
    } : {})
  },
  rightSection: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingLeft: spacing('lg'),
  },
  logoutButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: spacing('xs'),
    paddingHorizontal: spacing('sm'),
    borderRadius: getBorderRadius('md'),
    borderWidth: 1,
    borderColor: getColor('error.main'),
  },
  logoutText: {
    color: getColor('error.main'),
    marginLeft: spacing('xs'),
  },
});

export default AdminHeader;
